export const GEOLOCATION_DATA = "/lms/api/v1/asset/dp/geoLocation";
